module.exports = __webpack_public_path__ + "img/img-clue-index .1dfd4eba.png";